// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import contactConsentEntity from './entities/contact-consent.json';
import contactConsentMenu from '../pages/contact-consent/menu.json';
import contactConsentFullForm from '../pages/contact-consent/forms/full.json';
import contactConsentContextForm from '../pages/contact-consent/forms/context.json';
import contactConsentMiniForm from '../pages/contact-consent/forms/mini.json';
import contactConsentLookupForm from '../pages/contact-consent/forms/lookup.json';
import contactConsentTableView from '../pages/contact-consent/views/table.json';
import contactConsentCardsView from '../pages/contact-consent/views/cards.json';
import contactConsentCalendarView from '../pages/contact-consent/views/calendar.json';
import contactConsentDashboardView from '../pages/contact-consent/views/dashboard.json';

/** Тип запису «Згода контакту» зі сторінками пакета: меню, форми та подання з pages/contact-consent/. */
export const contactConsentDefinition: IRecordTypeDefinition = {
  ...contactConsentEntity,
  views: assembleViewSet({
      table: contactConsentTableView,
      cards: contactConsentCardsView,
      calendar: contactConsentCalendarView,
      dashboard: contactConsentDashboardView,
  }),
  form: contactConsentFullForm,
  forms: { full: contactConsentFullForm, context: contactConsentContextForm, mini: contactConsentMiniForm, lookup: contactConsentLookupForm },
  menu: contactConsentMenu,
} as IRecordTypeDefinition;
